
<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="关键字">
              <a-input v-model="queryParam.keywords" allowClear  placeholder="搜索关键字"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="赛季赛区">
              <a-cascader  :show-search="{ sjsqFilter }"  :options="sjsqOptions" :fieldNames="{ label: 'name', value: 'id', children: 'children' }" placeholder="请选择赛区" v-model="queryParam.sjsq" changeOnSelect />
            </a-form-item>
          </a-col>

          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="省市">
                <a-cascader :options="areaOptions" placeholder="请选择地区" v-model="queryParam.namekeys" changeOnSelect
                />
              </a-form-item>
            </a-col>

          </template>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px" >
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator" >
      <a-button @click="download(1)" style="margin-left: 8px;margin-bottom: 8px"  >
        住宿安排表(导出) <a-icon type="download" />
      </a-button>

      <a-upload
              name="file"
              accept=".xlsx"
              action
              :before-upload="beforeUpload3"
              style="margin-left: 8px;float: left"
      >
      <a-button  style="margin-left: 8px"  >
        住宿安排表(导入) <a-icon type="upload" />
      </a-button>
      </a-upload>

      <a-button @click="download(2)" style="margin-left: 8px"  >
        接站安排表(导出) <a-icon type="download" />
      </a-button>

      <a-upload
              name="file"
              accept=".xlsx"
              action
              :before-upload="beforeUpload1"
              style="margin-left: 8px;float: left"
      >
        <a-button>
          接站安排表(导入)
          <a-icon type="upload" />
        </a-button>
      </a-upload>
      <a-upload
              name="file"
              accept=".xlsx"
              action
              :before-upload="beforeUpload2"
              style="margin-left: 8px;float: left"
      >
        <a-button>
          送站安排表(导入)
          <a-icon type="upload" />
        </a-button>
      </a-upload>

      <a-button @click="download(3)" style="margin-left: 8px"  >
        送站安排表(导出) <a-icon type="download" />
      </a-button>

<!--      <a-button @click="download(4)" style="margin-left: 8px"  >-->
<!--        信息核对详情表 <a-icon type="download" />-->
<!--      </a-button>-->

<!--      <a-button @click="download(5)" style="margin-left: 8px"  >-->
<!--        接送站表 <a-icon type="download" />-->
<!--      </a-button>-->
      <a-button @click="confirmShow = true" style="margin-left: 8px"  >
        信息核对二维码
      </a-button>

    </div>

    <s-table
            ref="table"
            size="default"
            :columns="columns"
            :data="loadData"
            :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
            :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >
      <span slot="danwei" slot-scope="text,record">
          <div style="margin-left: 10px; float: left">
            {{record.danwei}}<br/>
            {{record.saiqu_name}}
            <br/><span style="color: #999">{{record.mingcheng}}</span>
            <br/>
            {{record.create_time|timeFormat}}
            <br/>
          </div>
      </span>
      <span slot="status" slot-scope="text,record">

        <p>秩序册状态
          <a-dropdown :trigger="['click']">
            <a-tag v-if="record.confirm_1==2" >待确认<a-icon type="form" /></a-tag>
            <a-tag v-if="record.confirm_1==1" color="green" >已确认<a-icon type="form" /></a-tag>
            <a-menu slot="overlay"  >
              <a-menu-item key="0" @click="setStatus('confirm_1',2,record)">
                <a  >待确认</a>
              </a-menu-item>
              <a-menu-item key="1" @click="setStatus('confirm_1',1,record)">
                <a  >已确认</a>
              </a-menu-item>
            </a-menu>
        </a-dropdown>
        <p>项目状态
          <a-dropdown :trigger="['click']">
            <a-tag v-if="record.confirm_2==2" >待确认<a-icon type="form" /></a-tag>
            <a-tag v-if="record.confirm_2==1" color="green" >已确认<a-icon type="form" /></a-tag>
            <a-menu slot="overlay"  >
              <a-menu-item key="0" @click="setStatus('confirm_2',2,record)">
                <a  >待确认</a>
              </a-menu-item>
              <a-menu-item key="1" @click="setStatus('confirm_2',1,record)">
                <a  >已确认</a>
              </a-menu-item>
            </a-menu>
        </a-dropdown></p>
        <p>食宿状态
        <a-dropdown :trigger="['click']">
            <a-tag v-if="record.confirm_3==2" >待确认<a-icon type="form" /></a-tag>
            <a-tag v-if="record.confirm_3==1" color="green" >已确认<a-icon type="form" /></a-tag>
            <a-menu slot="overlay"  >
              <a-menu-item key="0" @click="setStatus('confirm_3',2,record)">
                <a  >待确认</a>
              </a-menu-item>
              <a-menu-item key="1" @click="setStatus('confirm_3',1,record)">
                <a  >已确认</a>
              </a-menu-item>
            </a-menu>
        </a-dropdown></p>
        <p>接站状态
        <a-dropdown :trigger="['click']">
            <a-tag v-if="record.confirm_4==2" color="blue">待填写<a-icon type="form" /></a-tag>
            <a-tag v-if="record.confirm_4==3" >待确认<a-icon type="form" /></a-tag>
            <a-tag v-if="record.confirm_4==4" color="black">不需要<a-icon type="form" /></a-tag>
            <a-tag v-if="record.confirm_4==1" color="green" >已确认<a-icon type="form" /></a-tag>
            <a-menu slot="overlay"  >
              <a-menu-item key="0" @click="setStatus('confirm_4',2,record)">
                <a  >待填写</a>
              </a-menu-item>
              <a-menu-item key="1" @click="setStatus('confirm_4',3,record)">
                <a  >待确认</a>
              </a-menu-item>
              <a-menu-item key="2" @click="setStatus('confirm_4',4,record)">
                <a  >不需要</a>
              </a-menu-item>
              <a-menu-item key="3" @click="setStatus('confirm_4',1,record)">
                <a  >已确认</a>
              </a-menu-item>
            </a-menu>
        </a-dropdown></p>
        <p>送站状态
        <a-dropdown :trigger="['click']">
            <a-tag v-if="record.confirm_5==2" color="blue">待填写<a-icon type="form" /></a-tag>
            <a-tag v-if="record.confirm_5==3" >待确认<a-icon type="form" /></a-tag>
            <a-tag v-if="record.confirm_5==4" color="black">不需要<a-icon type="form" /></a-tag>
            <a-tag v-if="record.confirm_5==1" color="green" >已确认<a-icon type="form" /></a-tag>
            <a-menu slot="overlay"  >
              <a-menu-item key="0" @click="setStatus('confirm_5',2,record)">
                <a  >待填写</a>
              </a-menu-item>
              <a-menu-item key="1" @click="setStatus('confirm_5',3,record)">
                <a  >待确认</a>
              </a-menu-item>
              <a-menu-item key="2" @click="setStatus('confirm_5',4,record)">
                <a  >不需要</a>
              </a-menu-item>
              <a-menu-item key="3" @click="setStatus('confirm_5',1,record)">
                <a  >已确认</a>
              </a-menu-item>
            </a-menu>
        </a-dropdown></p>

      </span>
      <span slot="action" slot-scope="text,record">
        <template >
<!--            <a @click="download('jiudian',record)">酒店详情表</a>-->
<!--           <br/>-->
<!--            <a @click="download('baoming',record)">报名信息表</a>-->
<!--           <br/>-->
            <a @click="onH5Share(record)">查看</a>
        </template>
      </span>
    </s-table>

    <a-modal
        :maskClosable="false" title="查看" v-model="h5ShareVisible" @ok="h5ShareVisible=false">
      <p style="text-align: center">
        <img :src="share.wxmini_pic_url" />
      </p>
      <p>详情地址</p>
      <p>{{share.site_url}} </p><a
            v-clipboard:copy="share.site_url"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError">点此复制</a>
    </a-modal>
    <a-modal
        :maskClosable="false" title="核对详情二维码" v-model="confirmShow" @ok="confirmShow=false">
      <p style="text-align: center">
        <img src="@assets/images/confirm-img.png" />
      </p>
    </a-modal>

  </a-card>
</template>

<script>
  import STable from '@/components/table/'
  import ATextarea from 'ant-design-vue/es/input/TextArea'
  import AInput from 'ant-design-vue/es/input/Input'
  import EditableCell from '@/components/EditableCell/'
  import PicUploader from '@/components/PicUploader/'
  import FileUploader from '@/components/FileUploader/'
  import JiaolianPicker from '@/components/JiaolianPicker/'
  import CaipanPicker from '@/components/CaipanPicker/'
  import areaOptions from '@/utils/area'
  import moment from 'moment'
  import setting from '@/config/setting'
  import 'moment/locale/zh-cn';
  moment.locale('zh-cn');
  import XLSX from "xlsx";

  import { getConfrimApplyList ,setConfrimStatus,sjsqOptions ,busgetImport,busgoImport,zhusuImport} from '@/api/sai'
  export default {
    name: 'KaojiApplyList',
    components: {
      AInput,
      ATextarea,
      FileUploader,
      PicUploader,
      STable,
      EditableCell,
      CaipanPicker,
      JiaolianPicker,
    },
    data () {
      return {
        areaOptions,
        visible: false,
        orderVisible: false,
        h5ShareVisible: false,
        saveLoading:false,
        jiaolianPickerShow:false,
        caipanPickerShow:false,
        confirmShow:false,
        sjsqOptions:[],
        xlsxJson:[],
        hotelListForm:{
          list:[]
        },
        wb:{},
        share: {
          wxmini_pic_url: '',
          site_url:'',
        },
        orderFormData:{

        },
        formData:{
          id:0,
          danwei:'',
          mingcheng:'',
          datetitle_moment:null,
          datetitle:'',
          heying:[],
          jiaolian:[],
          caipan:[],
          subjectlist:[],
          loglist:[],
        },
        time_range_moment:[],
        time_range:[],
        labelCol: {
//          xs: { span: 24 },
//          sm: { span: 5 },
          xs: { span: 24 },
          sm: { span: 8 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12 },
        },
        form: this.$form.createForm(this),
        mdl: {},

        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {
          keywords:'',
          sjsq:[]
        },
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: 'id',
            width: '50px'
          },
          {
            title: '报名信息',
            dataIndex: 'danwei',
            scopedSlots: { customRender: 'danwei' },
          },
          {
            title: '状态',
            dataIndex: 'status',
            width: '200px',
            scopedSlots: { customRender: 'status' },
          },
          {
            title: '操作',
            dataIndex: 'action',
            fixed: 'right',
            width: 220,
            scopedSlots: { customRender: 'action' },
          }
        ],
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          console.log('loadData');
          console.log(this.queryParam);
          let that= this;

          if (this.time_range_moment[0] && this.time_range_moment[1]) {
            this.queryParam.time_range = [
              this.time_range_moment[0].format('YYYY-MM-DD HH:mm:ss'),
              this.time_range_moment[1].format('YYYY-MM-DD HH:mm:ss')
            ]
          } else {
            this.queryParam.time_range = []
          }

          this.queryParam = Object.assign(this.queryParam,parameter);
          return getConfrimApplyList(this.queryParam)
                  .then(res => {
                    console.log('res');
                    return res.data
                  })
        },

        selectedRowKeys: [],
        selectedRows: [],
        cashFormData:{
          ids:[],
          to_type:'',
          price:0,
          note:'',
          count:0,
        }
      }
    },
    computed:{
    },
    created(){
    },

    mounted(){
      let that = this;
      that.getSjsqOptions();
    },
    methods: {
      moment,
      getSjsqOptions(){
        let that = this;
        sjsqOptions({}).then(res =>{
          that.sjsqOptions = res.data;
        });
      },

      download(type,record){
        console.log('this.queryParam')
        console.log(this.queryParam)

        switch (type){
          case 'jiudian':
            window.open(setting.apiBaseURL+'/adminapi/sai/hotelDetailTable?id='+record.id);
            return false ;
            break;
          case 'baoming':
            window.open(setting.apiBaseURL+'/adminapi/sai/baomingDetailTable?id='+record.id);
            return false ;
            break;
        }
        if(typeof this.queryParam.sjsq == 'undefined' || this.queryParam.sjsq.length !=2){
          this.$message.error('请先选择赛区');
          return ;
        }
        switch (type){
          case 1:
            window.open(setting.apiBaseURL+'/adminapi/sai/zhusuDownload?saiqu='+this.queryParam.sjsq[1]);
            break;
          case 2:
            window.open(setting.apiBaseURL+'/adminapi/sai/busgettable?saiqu='+this.queryParam.sjsq[1]);
            break;
          case 3:
            window.open(setting.apiBaseURL+'/adminapi/sai/busgotable?saiqu='+this.queryParam.sjsq[1]);
            break;
          case 4:
            window.open(setting.apiBaseURL+'/adminapi/sai/confirmmanageTable?saiqu='+this.queryParam.sjsq[1]);
            break;
          case 5:
            window.open(setting.apiBaseURL+'/adminapi/sai/busalltable?saiqu='+this.queryParam.sjsq[1]);
            break;

        }
      },

      setStatus(type,status,record){
        let self =this;
        setConfrimStatus({
          id: record.id,
          status: status,
          type: type
        })
                .then(res => {
                  self.$refs.table.refresh()
                })
                .catch(err => {
                  self.$message.error(err.data.msg)
                })
      },

      onH5Share(record) {
        console.log(record)
        let that = this
        that.share.site_url=record.h5_url
        that.h5ShareVisible = true
        that.share.wxmini_pic_url = record.h5_pic_url
      },
      onCopy(e){
        this.$message.success('复制成功')
      },
      onError(e){
        this.$message.error('复制失败')
      },

      beforeUpload1(file) {
        let that = this
        let formdata = new FormData()
        console.log(file)
        formdata.append('upfile', file)
        console.log('formdata', formdata)
        busgetImport(formdata)
                .then(res => {
                  that.$message.success('上传成功')
                  that.load();
                })
                .catch(err => {
                  that.$message.error(err.data.msg)
                })
        return false // false就是不自动上传，我后来试了发现都一样，都不会自动上传
      },

      beforeUpload2(file) {
        let that = this
        let formdata = new FormData()
        console.log(file)
        formdata.append('upfile', file)
        console.log('formdata', formdata)
        busgoImport(formdata)
                .then(res => {
                  that.$message.success('上传成功')
                  that.load();
                })
                .catch(err => {
                  that.$message.error(err.data.msg)
                })
        return false // false就是不自动上传，我后来试了发现都一样，都不会自动上传
      },



    beforeUpload3(file) {
      // let file = file.files[0] // 使用传统的input方法需要加上这一步
      let that = this;
      const types = file.name.split(".")[1];
      const fileType = ["xlsx", "xlc", "xlm", "xls", "xlt", "xlw", "csv"].some(
        (item) => item === types
      );
      if (!fileType) {
        alert("格式错误！请重新选择");
        return;
      }
      this.file2Xce(file).then((tabJson) => {
        if (tabJson && tabJson.length > 0) {
          this.xlsxJson = tabJson;
          console.log("this.xlsxJson", this.xlsxJson);
          that.hotelListForm.list = [];

          that.xlsxJson[0].sheet.map((item) => {
            that.hotelListForm.list.push({
              hotel_name: item["酒店名称"]||'',
              hotel_address: item["酒店地址"]||'',
              dinner: item["用餐信息"]||'',
              bus_name: item["赛中车辆信息"]||'',
              id: item["ID"]||'',
              edit: false,
            });
          });

          console.log('that.hotelListForm.list',that.hotelListForm.list);
        zhusuImport({
          list:that.hotelListForm.list
        })
                .then(res => {
                  that.$message.success('上传成功')
                })
                .catch(err => {
                  that.$message.error(err.data.msg)
                })
          // xlsxJson就是解析出来的json数据,数据格式如下
          // [
          //   {
          //     sheetName: sheet1
          //     sheet: sheetData
          //   }
          // ]
        }
      });
      return true;
    },
    file2Xce(file) {
      return new Promise(function (resolve, reject) {
        const reader = new FileReader();
        reader.onload = function (e) {
          const data = e.target.result;
          this.wb = XLSX.read(data, {
            type: "binary",
          });
          const result = [];
          this.wb.SheetNames.forEach((sheetName) => {
            result.push({
              sheetName: sheetName,
              sheet: XLSX.utils.sheet_to_json(this.wb.Sheets[sheetName]),
            });
          });
          resolve(result);
        };
        // reader.readAsBinaryString(file.raw)
        reader.readAsBinaryString(file); // 传统input方法
      });
    },


      //展开关闭
      toggleAdvanced() {
        this.advanced = !this.advanced
      },
      // 查
      onSearch() {
        let self = this;
        self.$refs.table.refresh(false)
      },
      onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },
            sjsqFilter(inputValue, path) {
            return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
            },

    },
    filters:{
    },
    watch: {
    }
  }
</script>
